import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"id":"game"}},[(!_vm.sesh.session)?_c('loader'):_c('jumble')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }